export type MarketingPartnerBrand = {
  src: string;
  alt: string;
  /** Intrinsic pixel dimensions — used for aspect ratio only. */
  width: number;
  height: number;
};

export const MARKETING_PARTNER_BRANDS: MarketingPartnerBrand[] = [
  {
    src: "/brands/concentrix.webp",
    alt: "Concentrix",
    width: 308,
    height: 48,
  },
  {
    src: "/brands/Bancolombia.svg",
    alt: "Bancolombia",
    width: 160,
    height: 45,
  },
  {
    src: "/brands/Leavitt.svg",
    alt: "Leavitt Group",
    width: 1500,
    height: 480,
  },
  {
    src: "/brands/cottingham.webp",
    alt: "Cottingham & Butler",
    width: 2157,
    height: 751,
  },
  {
    src: "/brands/insurance-nation.webp",
    alt: "Insurance Nation",
    width: 474,
    height: 112,
  },
  {
    src: "/brands/StateFarm.svg",
    alt: "State Farm",
    width: 776,
    height: 108,
  },
  {
    src: "/brands/neo-insurance.webp",
    alt: "NEO Insurance Solutions",
    width: 542,
    height: 112,
  },
  {
    src: "/brands/Allstate.webp",
    alt: "Allstate",
    width: 232,
    height: 50,
  },
];
